import script from "./rulePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./rulePopup.vue?vue&type=script&setup=true&lang=ts"

import "./rulePopup.vue?vue&type=style&index=0&id=01de8c5a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01de8c5a"]])

export default __exports__